module.exports = __webpack_public_path__ + "img/testing spk.e6d30422.jpg";